import React from "react";
import { Login, OtpVervicatonForm } from "../features/Auth/LoginRegister";
import styles from "../assets/css/utils.module.css";
import { Helmet } from "react-helmet";
import { useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  WhatsappShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
} from "react-share";
import {
  linkdinLogin,
  fbllogin,
  whatsApp2,
  twitter2,
  email2,
} from "../assets/images/index";
import { useLocation } from "react-router-dom";

export const SocialShare = ({ item }) => {
  const handleShare = async (platform) => {
    try {
      const image =
        item?.product_images?.length > 0
          ? item.product_images[0]?.product_images
          : "";
      if (!image) {
        console.error("Image not available for sharing.");
        return;
      }
  
      const encodedEquipName = encodeURIComponent(item?.equip_name);
      const url = `https://equipmedy.com/products/${encodedEquipName}/?id=${item?.id}/`;
      const shareText = `
        Check out this amazing product!
        
        🖼️ Image: ${image}
        📌 Name: ${item?.equip_name}
        ✍️ Description: ${item?.other_details}
        🔗 Link: ${url}
      `;
  
      switch (platform) {
        case "facebook":
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              url
            )}&quote=${encodeURIComponent(shareText)}`,
            "_blank"
          );
          break;
  
        case "whatsapp":
          window.open(
            `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`,
            "_blank"
          );
          break;
  
        case "twitter":
          window.open(
            `https://twitter.com/intent/tweet?text=${encodeURIComponent(
              shareText
            )}`,
            "_blank"
          );
          break;
  
          case "linkedin":
            window.open(
              `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${encodeURIComponent(
                item?.equip_name
              )}&summary=${encodeURIComponent(shareText)}&source=${encodeURIComponent(image)}`,
              "_blank"
            );
            break;
  
        default:
          console.error("Unsupported platform");
          break;
      }
    } catch (error) {
      console.error("Error sharing:", error);
    }
  };

  const encodedEquipName = encodeURIComponent(item?.equip_name);
  const url = `${encodedEquipName}/?id=${item?.id}/`;

  const shareUrl = `https://equipmedy.com/products/${url}`;

  return (
    <React.Fragment>
      <button
        onClick={() => handleShare("facebook")}
        className="transition-transform hover:scale-110"
      >
        <FacebookIcon size={40} round />
      </button>
      <button
        onClick={() => handleShare("whatsapp")}
        className="transition-transform hover:scale-110"
      >
        <WhatsappIcon size={40} round />
      </button>

      <TwitterShareButton
        url={shareUrl}
        title={`${item.equip_name}\n${item.description}\n${item.speciality_name}`}
        hashtags={[`${item.equip_name}`, "Equipmeady", "Equipmeady"]}
      >
        <TwitterIcon size={32} round />
      </TwitterShareButton>

      <button
        onClick={() => handleShare("linkedin")}
        className="transition-transform hover:scale-110"
      >
        <LinkedinIcon size={40} round />
      </button>
    </React.Fragment>
  );
};


export const GetStarted = (props) => {
  const [otpForm, setOtpForm] = useState(false);
  const [otp, setotp] = useState("");
  const [number, setNumber] = useState("");
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");

  const handleClose = () => {
    props.setGetStart(false);
    props.setBlur(false);
  };
  const title = "Get Started";
  const title2 = "Sign In with your mobile number To access your account";

  return (
    <div className={styles.getStartContainer}>
      <div>
        {otpForm ? (
          ""
        ) : (
          <React.Fragment>
            <div className={styles.getStartTop}>
              <b>
                <i onClick={handleClose} class="bi bi-x-lg"></i>
              </b>
              <h2> {title} </h2>
            </div>
            <p className={styles.getStartInd}> {title2}</p>
          </React.Fragment>
        )}
        {otpForm ? (
          <OtpVervicatonForm
            getOtp={otp}
            setotp={setotp}
            number={number}
            firstName={fname}
            lastName={lname}
            setGetStart={props.setGetStart}
            setBlur={props.setBlur}
          />
        ) : (
          <Login
            setOtpForm={setOtpForm}
            setotp={setotp}
            setNumber={setNumber}
            setFirstName={setfname}
            setLastName={setlname}
          />
        )}
      </div>
    </div>
  );
};

export const TextModel = (props) => {
  let msg = props.msg;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100px",
      }}
    >
      <p className={styles.pText}>{msg}</p>
      <div className={styles.buttonDec}>
        <button
          onClick={() => {
            props.setRescheduled("Rescheduled");
            // cancelBtn(false);
            props.setSheduleLis("");
          }}
          className={styles.btnDec}
        >
          Rescheduled
        </button>
        <button
          onClick={() => props.setSheduleLis("")}
          className={styles.btnDec1}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export const MSGBox = (props) => {
  const handleClick = () => {
    props.handlePop(!props.msg);
  };
  return (
    <div className={styles.msgBoxCont}>
      <p>
        <i onClick={handleClick} className="bi bi-x-lg"></i>
      </p>
      <span>{props.msgCont}</span>
    </div>
  );
};

export const BackgroundBlur = () => {
  return <div className={styles.bgBlur}></div>;
};




